import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextValidator } from 'react-material-ui-form-validator';
import { Grid, FormControlLabel, Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';

class Toggle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, state, } = this.props;
    return (
      <>
      <Grid item md={12} xs={12}>
        <FormControlLabel
          control={
            <Switch
              checked={this.props.checked}
              onChange={e => {
                this.props.handleChange(e);
              }}
              name={this.props.name}
              color="primary"
            />
          }
          label={this.props.label}
          className={classes.labelClass}
        />
      </Grid>
      {state && state.values.whitelist_guests_email && this.props.name == "whitelist_guests_email" &&
        <Grid item md={6} xs={12}>
          <TextValidator
            fullWidth
            placeholder="Enter domains here (with ,)"
            id="whitelist_domain"
            name="whitelist_domain"
            className={classes.textField}
            onChange={this.props.handleChange}
            margin="dense"
            value={state.values.whitelist_domain}
            InputLabelProps={{
              shrink: true,
              style: { fontSize: 20, top: '-5px', fontWeight: 'bold' }
            }}
          />
        </Grid>
      }
      </>
    );
  }
}

Toggle.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Toggle);
